import { LoggerLevelEnum } from "@/enums";
import { AppError } from "@/errors";

export function getEnvOrThrow(names: string | string[]): string;
export function getEnvOrThrow(value: string | undefined, label: string): string;
export function getEnvOrThrow(
  a: string | string[] | undefined,
  b?: string,
): string {
  // Public/client-safe variant: pass inlined value and its label
  if (typeof b === "string") {
    const value = a as string | undefined;
    if (value !== undefined && value !== "") return value;

    throw new AppError(
      "ENV_MISSING",
      `Missing required environment variable(s): ${b}`,
      {
        severity: LoggerLevelEnum.FATAL,
        meta: { label: b },
      },
    );
  }

  // Server variant: resolve names from process.env (supports OR)
  const nameList = Array.isArray(a) ? a : [a as string];
  for (const name of nameList) {
    const value = process.env[name];
    if (value !== undefined && value !== "") {
      return value;
    }
  }

  throw new AppError(
    "ENV_MISSING",
    `Missing required environment variable(s): ${nameList.join(" or ")}`,
    {
      severity: LoggerLevelEnum.FATAL,
      meta: { names: nameList },
    },
  );
}
